import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import ConditionalComponent from './ConditionalComponent';
import ScenarioModalContainer
  from './../Containers/ScenarioModalContainer';

const ViewScenarioStatusComponent = ({
  dispatcherId,
  verdictReason,
  verdictStatus,
  scenarioReason,
  scenarioStatus,
  onStatusClick
}) => {
  let verdictColor = {};
  if (verdictStatus === 'COMPLETED') {
    verdictColor = { color: 'green' };
  }
  else if (['FAILED', 'ERROR'].includes(verdictStatus)) {
    verdictColor = { color: 'red' };
  }

  let scenarioColor = {};
  if (scenarioStatus === 'COMPLETED') {
    scenarioColor = { color: 'green' };
  }
  else if (['FAILED', 'ERROR'].includes(scenarioStatus)) {
    scenarioColor = { color: 'red' };
  }

  return (
    <div>
      <ScenarioModalContainer />
      <ConditionalComponent condition={dispatcherId > 0}>
        <Col sm={3}>
          <Button
            id="button-scenario"
            bsSize="small"
            onClick={() => onStatusClick(dispatcherId)}
          >
            View Dispatcher Scenario Statuses
          </Button>
        </Col>
        <Col sm={5}>
          <Row>
            <h4 style={{
              textAlign: 'left',
              paddingLeft: '10%',
              ...scenarioColor
            }}
            >
              Scenario Status: {scenarioStatus}
            </h4>
          </Row>
          <ConditionalComponent condition={!!scenarioReason}>
            <h5 style={{
              textAlign: 'left',
              paddingLeft: '10%',
              marginTop: '-2%',
              ...scenarioColor
            }}
            >
              Reason: {scenarioReason}
            </h5>
          </ConditionalComponent>

          <Row>
            <h4 style={{
              textAlign: 'left',
              paddingLeft: '10%',
              ...verdictColor
            }}
            >
              Overall Verdict: {verdictStatus}
            </h4>
          </Row>
          <ConditionalComponent condition={!!verdictReason}>
            <h5 style={{
              textAlign: 'left',
              paddingLeft: '10%',
              marginTop: '-2%',
              ...verdictColor
            }}
            >
              Reason: {verdictReason}
            </h5>
          </ConditionalComponent>
        </Col>
      </ConditionalComponent>
    </div>
  );
};

ViewScenarioStatusComponent.propTypes = {
  dispatcherId: PropTypes.number.isRequired,
  verdictReason: PropTypes.string,
  verdictStatus: PropTypes.string,
  scenarioReason: PropTypes.string,
  scenarioStatus: PropTypes.string,
  onStatusClick: PropTypes.func.isRequired
};

export default ViewScenarioStatusComponent;


// WEBPACK FOOTER //
// src/Components/ViewScenarioStatusComponent.jsx